import React, { useEffect, useState } from "react";
import shelf from "../assets/shelf.png";
import birds from "../assets/birds.png";
import butterfly from "../assets/butterfly.png";
import sun from "../assets/sun.png";
import cloud from "../assets/cloud.png";
import nophone from "../assets/nophone.webp";
import flowerscollage from "../assets/flowerscollage.png";
import "./mobilegate.css";

const STAGE_WIDTH = 1650;
const STAGE_HEIGHT = 960;

const getStageScale = () => {
  if (typeof window === "undefined") {
    return 0.52;
  }

  const availableWidth = Math.max(window.innerWidth - 32, 280);
  const availableHeight = Math.max(window.innerHeight - 260, 340);

  return Math.min(availableWidth / STAGE_WIDTH, availableHeight / STAGE_HEIGHT, 0.56);
};

const MobileGate = () => {
  const [stageScale, setStageScale] = useState(getStageScale);

  useEffect(() => {
    const handleResize = () => {
      setStageScale(getStageScale());
    };

    handleResize();
    window.addEventListener("resize", handleResize, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <main className="mobile_gate">
      <div className="mobile_gate_scene" aria-hidden="true">
        <div
          className="mobile_gate_stage"
          style={{ transform: `translateY(24px) scale(${stageScale})` }}
        >
          <img src={shelf} className="mobile_gate_shelf" alt="" />
          <img src={birds} className="mobile_gate_birds" alt="" />
          <img src={butterfly} className="mobile_gate_butterfly" alt="" />
          <img src={sun} className="mobile_gate_sun" alt="" />
          <img src={cloud} className="mobile_gate_cloud" alt="" />
          <img src={nophone} className="mobile_gate_phone" alt="" />
          <img src={flowerscollage} className="mobile_gate_flowers" alt="" />
        </div>
      </div>

      <section className="mobile_gate_panel">
        <p className="mobile_gate_code">Preview Unavailable</p>
        <h1 className="mobile_gate_title">Can&apos;t preview this website on mobile view.</h1>
        <p className="mobile_gate_text">
          Open it on a screen wider than 900px to explore the full experience.
        </p>
      </section>
    </main>
  );
};

export default MobileGate;
